import { useEffect, useState } from "react";

/**
 * Global ⌘K / Ctrl+K toggle.
 *
 * Bound on `document` rather than a container so the palette opens from any
 * route. The browser's own find-in-page shortcut is left alone; only the
 * meta/ctrl+K chord is claimed.
 */
export function useCommandPalette(): {
  open: boolean;
  setOpen: (open: boolean) => void;
} {
  const [open, setOpen] = useState(false);

  useEffect(() => {
    function onKeyDown(event: KeyboardEvent) {
      if (event.key.toLowerCase() !== "k") return;
      if (!event.metaKey && !event.ctrlKey) return;
      // Holding the chord auto-repeats keydown; each repeat would toggle.
      if (event.repeat) return;
      event.preventDefault();
      setOpen((previous) => !previous);
    }
    document.addEventListener("keydown", onKeyDown);
    return () => document.removeEventListener("keydown", onKeyDown);
  }, []);

  return { open, setOpen };
}
